/**
 * 倒计时组件
 */

import React, { useRef, useState } from 'react';
import styled from 'styled-components';

import { config, hooks, utils } from '@/lib';
import { UiModal } from '@/components';

type Props = {
  endTime: number;
  nowTime: number;
};
const PkBoardTime = (props: Props) => {
  const { nowTime = 0, endTime = 0 } = props;
  const diffTime = useRef(0);

  const getLabel = () => {
    const seconds = Math.floor(
      (endTime - (diffTime.current + Date.now())) / 1000,
    );
    const text = utils.getTimerText(seconds, {
      h: false,
    });
    return text;
  };

  const [label, setLabel] = useState(() => {
    diffTime.current = nowTime - Date.now();
    return getLabel();
  });

  hooks.useInterval(() => {
    setLabel(getLabel());
  }, 1000);

  const handelShowHelp = () => {
    UiModal.iframe({
      title: '',
      isH5Popup: true,
      url: `https://${config.domain.h5}/app/help?id=${
        config.staging ? '10079' : '10431'
      }`,
      // 'https://test-h5.2339.com/app/help?id=351?__r=1688699898216',
      width: 440,
      height: 600,
    });
  };

  return (
    <Wrap onClick={handelShowHelp}>
      <p className="count">
        PK中 <i>{label}</i>
      </p>
      <i className="iconfont icon-help-line" />
    </Wrap>
  );
};

const Wrap = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 116px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 22px;
  font-size: 12px;
  text-align: center;
  background: url(${require('../images/bg-pk-time.png')}) no-repeat center /
    contain;
  cursor: pointer;
  .count {
    display: inline-block;
    i {
      font-style: normal;
      min-width: 30px;
    }
  }
  .icon-help-line {
    position: relative;
    top: 1px;
    right: -2px;
    font-size: 13px;
  }
`;

export default PkBoardTime;
